import React, { useState } from 'react'
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Checkbox, Button } from 'antd';

import { Link } from "react-router-dom";
import creativetemicon from '../../assets/newlayout/modal_toggle_icon.svg';
import backButton from '../../assets/images/back_button_arrow.svg';
import zoneIcon from '../../assets/newlayout/editable_zone_icon.svg';
const { TextArea } = Input;

const RowEditableCom = () => {

    const [search, setSearch] = useState("")

    const onChange = e => {
        console.log(`checked = ${e.target.checked}`);
    };
    const dataSource = [
        {
            key: "apply-all",
            isApplyAll: true,
        },
        {
            key: 1,
            zoneName: "PlayWorks-CTV-Video-US-Gambling-118",
            zoneId: "77232",
            status: "Enabled",
            minEcpm: "4.4",
            sensitiveCategory: "4 blocked",
        },
        {
            key: 2,
            zoneName: "PlayWorks-CTV-Video-US-KR-Gaming-118",
            zoneId: "377163",
            status: "Enabled",
            minEcpm: "2.3",
            sensitiveCategory: "None",
        },
        {
            key: 2,
            zoneName: "PlayWorks-CTV-Video-US-KR-Gaming-118",
            zoneId: "377163",
            status: "Enabled",
            minEcpm: "2.3",
            sensitiveCategory: "None",
        },
        {
            key: 2,
            zoneName: "PlayWorks-CTV-Video-US-KR-Gaming-118",
            zoneId: "377163",
            status: "Enabled",
            minEcpm: "2.3",
            sensitiveCategory: "None",
        },
        {
            key: 2,
            zoneName: "PlayWorks-CTV-Video-US-KR-Gaming-118",
            zoneId: "377163",
            status: "Enabled",
            minEcpm: "2.3",
            sensitiveCategory: "None",
        },
    ];


    const columns = [
        {
            title: "Zone Name",
            dataIndex: "zoneName",
            width: 300,
            render: (_, record) => {
                if (record.isApplyAll) {
                    return (
                        <div className="apply_all_row">
                            <span className="dot"></span>
                            <span className="apply_text">
                                Apply to All
                            </span>
                            <span className="apply_desc">
                                fills all zones
                            </span>
                        </div>
                    );
                }

                return (
                    <>
                        <div className="zone_name_text">
                            {record.zoneName}
                        </div>
                        <div className="zone_id">
                            {record.zoneId}
                        </div>
                    </>
                );
            },
        },

        {
            title: "Status",
            dataIndex: "status",
            width: 130,
            render: (value, record) => {
                return (
                    <Select
                        className="form_select basic"
                        className={`form_select basic ${!record.isApplyAll ? "editable_select_tag badge_content--approved" : "editable_select_tag"
                            }`}
                        // archived declined approved -> this class for color change
                        style={{ width: !record.isApplyAll ? "" : "100%" }}
                        value={record.isApplyAll ? undefined : value}
                        dropdownStyle={{ width: "11rem" }}
                        placeholder={record.isApplyAll ? "" : undefined}
                        options={[
                            {
                                label: "Enabled",
                                value: "Enabled",
                            },
                            {
                                label: "Disabled",
                                value: "Disabled",
                            },
                            {
                                label: "Archive",
                                value: "Archive",
                            },
                        ]}
                        suffixIcon={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M4 6L8 10L12 6"
                                    stroke="#94A3B8"
                                    strokeWidth="1.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                    />
                );
            },
        },

        {
            title: "Min eCPM",
            dataIndex: "minEcpm",
            width: 120,
            render: (value, record) => {
                if (record.isApplyAll) {
                    return (
                        <div className="form_content_block--group">
                            <Input
                                prefix="$"
                                className='form_control basic prefix_sign'
                                placeholder="2.3"
                            />
                        </div>
                    );
                }

                return (
                    <div className="form_content_block--group">
                        <Input
                            value={value}
                            className='form_control basic prefix_sign'
                            prefix="$"
                        />
                    </div>
                );
            },
        },

        {
            title: "Max eCPM",
            dataIndex: "maxEcpm",
            width: 120,
            render: (_, record) => (
                <div className="form_content_block--group">
                    <Input
                        prefix="$"
                        placeholder="-"
                        className='form_control basic prefix_sign change_dot_cls'

                    />
                </div>
            ),
        },

        {
            title: "Requests / Day",
            dataIndex: "requests",
            width: 130,
            render: () => (
                <div className="form_content_block--group">
                    <Input
                        placeholder="-"
                        className='form_control basic'
                    />
                </div>
            ),
        },

        {
            title: "Impressions / Day",
            dataIndex: "impressions",
            width: 150,
            render: () => (
                <div className="form_content_block--group">
                    <Input
                        placeholder="-"
                        className='form_control basic'
                    />
                </div>
            ),
        },

        {
            title: "Rev Share %",
            dataIndex: "revShare",
            width: 150,
            render: () => (
                <div className="form_content_block--group">
                    <Input
                        suffix="%"
                        placeholder="-"
                        className='form_control basic subfix_sign'

                    />
                </div>
            ),
        },

        {
            title: "Partner Domain",
            dataIndex: "partnerDomain",
            width: 300,
            render: () => (
                <div className="form_content_block--group">
                    <Input
                        placeholder="-"
                        className='form_control basic'
                    />
                    <div className='form_content_block--group mt-1'>
                        <div className='primary_checkbox'>
                            <Checkbox onChange={onChange} style={{ fontSize: '1.2rem' }}>Pass Inventory Partner Domain</Checkbox>
                        </div>
                    </div>
                </div>
            ),
        },

        {
            title: "Human %",
            dataIndex: "human",
            width: 150,
            render: () => (
                <div className="form_content_block--group">
                    <Input
                        suffix="%"
                        placeholder="-"
                        className='form_control basic subfix_sign'
                    />
                </div>
            ),
        },

        {
            title: "Pixalate %",
            dataIndex: "pixalate",
            width: 150,
            render: () => (
                <div className="form_content_block--group">
                    <div className='zone_name_text'>309</div>
                </div>
            ),
        },

        {
            title: "Sensitive Category",
            dataIndex: "sensitiveCategory",
            width: 180,
            render: (value, record) => {
                if (record.isApplyAll) {
                    return (
                        <span className="sensitive_tag sensitive_tag_purple" onClick={() => setIsTemplateModalOpen(true)}>
                            None
                        </span>
                    );
                }

                if (value === "4 blocked") {
                    return (
                        <span className="sensitive_tag sensitive_tag_orange">
                            4 blocked
                        </span>
                    );
                }

                return (
                    <span className="sensitive_tag sensitive_tag_gray">
                        None
                    </span>
                );
            },
        },
    ];


    const [nameTemplate, setNameTemplate] = useState("");
    const [tagTemplate, setTagTemplate] = useState("");
    const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
    const [nameTemplateError, setNameTemplateError] = useState(false);
    const [tagTemplateError, setTagTemplateError] = useState(false);

    return (
        <div className="container_box--wrapper pt_header">
            <div className="container_box--breadcrumb">
                <ul className="container_box--breadcrumb-list">
                    <li>
                        <Link >
                            <img src={zoneIcon} alt="USP" /> Health Center
                        </Link>
                    </li>
                    <li className="primary"> Task-001</li>
                </ul>
            </div>
            <div className="container_box--wrapper--title d-flex align-items-center justify-content-between">
                <div className="back_btn_d2">
                    <img src={backButton} className="img-fluid" alt="" />
                    <div className="d-flex align-items-center" style={{ gap: "0.8rem" }}>
                        <h1 className="heading">
                            Back to Zones
                        </h1>
                        <small className="vertical_divider_line"></small>
                        <span className='bg_blue_badge'>5 Zones Selected</span>
                    </div>
                </div>
                <div className='apply_to_all_text'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_15218_25182)">
                            <path d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8C14.6668 4.3181 11.6821 1.33334 8.00016 1.33334C4.31826 1.33334 1.3335 4.3181 1.3335 8C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z" stroke="#155DFC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 5.33334V8" stroke="#155DFC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 10.6667H8.00667" stroke="#155DFC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_15218_25182">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    Use the  <span>Apply to All</span>row to fill all zones — or edit cells individually per zone.
                </div>
            </div>

            <div className="fixed_value_div">
                <p>Zone Type: <span>Vast Publica</span></p>
                <p>Traffic Type: <span>CTV</span></p>
                <p>Format Type: <span>Video</span></p>
                <p>Integration Type: <span>OpenRTB</span></p>
                <p>Is Zone Active: <span>Yes</span></p>
            </div>
            <div className="yellow_alert_box">
                <p><span>IVT Sampling note:</span> Changing Human % or Pixalate % impacts your effective bid price. Review floor prices after saving.</p>
            </div>



            <div className={dataSource.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                <div className="table_area_div">
                    <div className="searchbar_with_btns">
                        <div className="d_flex justify_content_between">
                            <div className="form_content_block--group">
                                <div className="tooltip_svg_icon_d2 position-relative --new_layout_search_input_design">

                                    <Input
                                        type='text'
                                        className='form_control basic md search_input w_table_search'
                                        placeholder="Search"
                                        value={search}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="table_content--box --new_layout_table_design table_empty_screen_d2 user_sync_table_v2">
                        <div className="zones_table_wrapper">
                            <Table
                                columns={columns}
                                dataSource={dataSource}
                                pagination={false}
                                bordered
                                scroll={{ x: dataSource.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 52.8rem' }}
                                rowClassName={(record) =>
                                    record.isApplyAll
                                        ? "apply_all_table_row"
                                        : ""
                                }
                            />
                            <div className="table_tags_text">
                                <p><small></small> Cell overrides Apply-All</p>
                                <p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_15218_24679)">
                                            <path d="M10.6665 3.33334H5.33317C2.75584 3.33334 0.666504 5.42268 0.666504 8.00001C0.666504 10.5773 2.75584 12.6667 5.33317 12.6667H10.6665C13.2438 12.6667 15.3332 10.5773 15.3332 8.00001C15.3332 5.42268 13.2438 3.33334 10.6665 3.33334Z" stroke="#B795EC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10.6665 10C11.7711 10 12.6665 9.10457 12.6665 8C12.6665 6.89543 11.7711 6 10.6665 6C9.56193 6 8.6665 6.89543 8.6665 8C8.6665 9.10457 9.56193 10 10.6665 10Z" stroke="#B795EC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_15218_24679">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Click to pick blocked categories per zone
                                </p>
                                <p>Empty cells = no change applied</p>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
            <div className="">
                <div className="hr_custom" style={{ margin: '1.2rem 0 1.6rem', backgroundColor: '#CBD5E1' }}></div>
                <div className="btn_group justify-content-end align-items-center gap_8">
                    <p className="m-0 btn_text_left"><strong>12</strong> values set across <strong>5</strong> zones</p>
                    <button className='w_120_d2 btn btn_white_outline w_fit_content'>Discard</button>
                    <button className='w_120_d2 btn btn_primary w_fit_content'>
                        <span>Save</span>
                    </button>
                </div>
            </div>

            <Modal
                className='custom_modal custom_modal_form_d2'
                open={isTemplateModalOpen}
                onCancel={() => setIsTemplateModalOpen(false)}
                width={770}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'>
                        <h3 className='heading'>
                            <img src={creativetemicon} alt='USP' />
                            Select Sensitive Category to block
                        </h3>
                    </div>
                }
                closable={true}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => setIsTemplateModalOpen(false)}>
                                Cancel
                            </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">
                                Apply
                            </button>
                        </div>
                    </div>
                ]}
            >
                <div className='modal_custom_body'>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Id animi dolorem enim ad libero dolor consectetur, harum error dolores voluptate obcaecati! Libero voluptates molestias tempora, dolorem eos in veniam facere.</p>
                </div>
            </Modal>

        </div>

    )
}

export default RowEditableCom
